import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from '@chakra-ui/react';
import { VSpacer } from '../spacers/spacer-vertical';
import { colors } from '../theme/colors';
import ExternalLinkIcon from '../icons/external-link';
export function AnchorButton(_ref) {
  var redirectLink = _ref.redirectLink,
      children = _ref.children,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? 'anchor-button' : _ref$id,
      _ref$bgColor = _ref.bgColor,
      bgColor = _ref$bgColor === void 0 ? colors.green : _ref$bgColor,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {
    return;
  } : _ref$onClick,
      _ref$isExternal = _ref.isExternal,
      isExternal = _ref$isExternal === void 0 ? true : _ref$isExternal;
  return /*#__PURE__*/_jsxs(Link, {
    href: redirectLink,
    isExternal: isExternal,
    onClick: onClick,
    id: id,
    bgColor: bgColor,
    h: "48px",
    w: "full",
    minW: {
      base: '240px',
      sm: '286px'
    },
    color: "white",
    pr: 8,
    pl: 8,
    borderRadius: "full",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textDecoration: "none",
    fontWeight: "bold",
    textTransform: "uppercase",
    _focus: {
      outline: 'none'
    },
    _hover: {
      boxShadow: 'lg'
    },
    children: [children, /*#__PURE__*/_jsx(VSpacer, {}), /*#__PURE__*/_jsx(ExternalLinkIcon, {})]
  });
}